import React, { useState, useEffect } from "react";
import lodash from "lodash";
import { Row, Col, Table, Popover } from "antd";
import moment from "moment";
//components
import DialogWeekEdit from "../dialog/dialog_week_edit";

import { useDispatch, useSelector } from "react-redux";
import { branchsSelector } from "../../../store/branch/branch.selector";
// import { staffsSelector } from "../../../store/staff/staff.selector";
import { usersSelector } from "../../../store/user/user.selector";
import { rosterSelector } from "../../../store/roster/roster.selector";

import { LEVELS } from "../../../store/string";
import "../style.css";

import { allStaffsSelector } from "../../../store/staff/staff.selector";

const RosterTable = (props) => {
  // -------------------------- VAR --------------------------
  const { branch, dates, copying, loading, rosterByStaff } = props;

  const { lockCurrentWeek } = props;
  // -------------------------- STATE --------------------------
  const [dataWeek, setDataWeek] = useState([]);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const users = useSelector(usersSelector);
  const branchs = useSelector(branchsSelector);
  // const rosters = useSelector(rosterSelector);
  const activeStaffs = useSelector(allStaffsSelector);
  // console.log({ activeStaffs });
  //   console.log({ dates });
  // -------------------------- FUNCTION -----------------------
  const handleClick = (select) => {
    if (loading || copying) {
      return;
    }
    if (select?.fullName !== "Total") {
      setSelected(select);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const afterClose = () => {
    setSelected(null);
    setDataWeek([]);
  };

  const sortData = (data) => {
    // console.log(data);
    const sortByName = lodash.sortBy(data, ["fullName"]);
    const sortOrder = [
      "Level 4",
      "Level 3",
      "Level 2",
      "Level 1",
      "Trainee",
      "empty",
      "total",
    ];
    const sortByLevel = lodash.sortBy(sortByName, (item) =>
      lodash.indexOf(sortOrder, item?.level)
    );

    return sortByLevel;
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------
  const columns = getHeader(branch, dates);

  const data = sortData(
    getDataRows(
      branch,
      branchs,
      // rosters,
      users,
      dates,
      activeStaffs,
      rosterByStaff
    )
  );

  // -------------------------- MAIN --------------------------
  return (
    <>
      <Table
        bordered
        className="table-roster"
        columns={columns}
        dataSource={data || []}
        pagination={false}
        onRow={(record) => ({
          onClick: () => handleClick(record),
        })}
        rowKey={(record) => record?.fullName}
      />
      <DialogWeekEdit
        open={open}
        setOpen={setOpen}
        data={dataWeek}
        branch={branch}
        setData={setDataWeek}
        handleClose={handleClose}
        afterClose={afterClose}
        selected={selected}
        setSelected={setSelected}
        lockCurrentWeek={lockCurrentWeek}
      />
    </>
  );
};

export default RosterTable;

const getHeader = (branches, dates) => {
  let header = [];
  const companyName = branches?.name || "";
  const companyheader = {
    key: "#",
    title: (
      <th
        style={{
          color: "#1976d2",
          fontWeight: "bold",
          fontSize: 12,
          scope: "col",
        }}
      >
        {companyName}
      </th>
    ),
    dataIndex: "fullName",
    render: (value, _record) => {
      // const level = _record?.level;
      const color = _record?.color;
      const style = {
        borderLeft: `5px solid ${color}`,
        fontSize: 12,
        padding: 10,
      };
      return <div style={style}>{value}</div>;
    },
  };
  const dateHeader = dates?.map((item, index) => {
    const label = moment(item, "ddd DD MMM YYYY").format("ddd DD");
    const order = index + 1;
    return {
      key: order,
      title: <div style={{ fontSize: 12 }}>{label}</div>,
      dataIndex: `Day${order}`,
      align: "center",
      ellipsis: true,
      width: "12%",
      render: (value) => getColor(value),
    };
  });

  header = [...header, companyheader, ...dateHeader];
  return header;
};

const getDataRows = (
  branch,
  branchs,
  // rosters,
  users,
  dates,
  activeStaffs,
  rosterByStaff
) => {
  let final = [];
  // filter active staff
  users?.forEach((user) => {
    const activeCoop = activeStaffs?.filter(
      (activeStaff) => activeStaff?.branch === branch?.id
    );
    const staffs = branch?.coop?.filter((staff) => {
      const included = activeCoop?.some((actived) => actived?.staff === staff);
      return included;
    });

    const userId = user?.id;
    if (staffs?.includes(userId)) {
      let row = {};
      const fullName =
        user?.preferredName || `${user?.firstName} ${user?.lastName}` || "";
      const level = user?.level || "empty";
      const color =
        LEVELS?.find((item) => item?.name === level)?.color || "#fd9644";
      const rosterArr = rosterByStaff?.[userId];
      row = {
        ...row,
        fullName,
        user: userId,
        branch: branch?.id,
        dates,
        rosters: rosterArr,
        branchs,
        level,
        color,
      };
      dates.forEach((d, i) => {
        const order = i + 1;
        const id = `Day${order}`;
        // const roster =
        //   rosters &&
        //   rosters.find((item) => item.staff === userId && item.date === d);
        const roster = rosterByStaff?.[userId]?.find(
          (item) => item?.date === d
        );
        const off = roster && roster.off;
        const label = roster ? "OFF" : "";
        row = { ...row, [id]: label };
        if (off === false) {
          const rosterBranch = roster && roster.branch;
          if (rosterBranch === branch?.id) {
            // Work At
            const workAt = roster && roster.workAt;
            const wSeconds = workAt && workAt.seconds;
            const workDate =
              wSeconds && moment(workAt.toDate()).format("hh:mm A");
            // End At
            const endAt = roster && roster.endAt;
            const eSeconds = endAt && endAt.seconds;
            const endDate =
              eSeconds && moment(endAt.toDate()).format("hh:mm A");
            const label = (
              <>
                <div style={{ color: "black", fontSize: 11 }}>{workDate}</div>
                <div style={{ color: "black", fontSize: 11 }}>{endDate}</div>
              </>
            );

            row = { ...row, [id]: label };
          } else {
            // nếu không phải
            const selectedBranch =
              branchs && branchs.find((item) => item.id === rosterBranch);
            const intial = selectedBranch && selectedBranch.shopId;
            const labelIntial = <div style={{ color: "orange" }}>{intial}</div>;

            row = { ...row, [id]: labelIntial };
          }
        }
      });

      final = [...final, row];
    }
  });

  // total Row
  const branchList = branchs?.map((branch) => branch.shopId);
  const Day1 = final?.filter(
    (item) =>
      item?.Day1 !== "OFF" &&
      item?.Day1 !== "" &&
      !branchList.includes(item.Day1.props.children)
  ).length;
  const Day2 = final?.filter(
    (item) =>
      item?.Day2 !== "OFF" &&
      item?.Day2 !== "" &&
      !branchList.includes(item.Day2.props.children)
  ).length;
  const Day3 = final?.filter(
    (item) =>
      item?.Day3 !== "OFF" &&
      item?.Day3 !== "" &&
      !branchList.includes(item.Day3.props.children)
  ).length;
  const Day4 = final?.filter(
    (item) =>
      item?.Day4 !== "OFF" &&
      item?.Day4 !== "" &&
      !branchList.includes(item.Day4.props.children)
  ).length;
  const Day5 = final?.filter(
    (item) =>
      item?.Day5 !== "OFF" &&
      item?.Day5 !== "" &&
      !branchList.includes(item.Day5.props.children)
  ).length;
  const Day6 = final?.filter(
    (item) =>
      item?.Day6 !== "OFF" &&
      item?.Day6 !== "" &&
      !branchList.includes(item.Day6.props.children)
  ).length;
  const Day7 = final?.filter(
    (item) =>
      item?.Day7 !== "OFF" &&
      item?.Day7 !== "" &&
      !branchList.includes(item.Day7.props.children)
  ).length;

  const totalRow = {
    fullName: "Total",
    Day1,
    Day2,
    Day3,
    Day4,
    Day5,
    Day6,
    Day7,
    level: "total",
  };

  return [...final, totalRow];
};

const getColor = (value) => {
  if (value === "OFF") {
    return <div style={{ fontSize: 12, color: "red" }}>{value}</div>;
  } else {
    return <div style={{ fontSize: 12, color: "orgrane" }}>{value}</div>;
  }
};
